export default __webpack_public_path__ + "static/media/Screenshot 2022-06-02 at 2.24.14 PM.247aa8eb.png";